import { useState, useEffect } from 'react';
import { AdminService } from '../../../../core/services/AdminService';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    label?:string;
    idSelector: number;
    onChange: any;
}

export const SelectorProcessTypeConstants = ({ idSelector, label,onChange }: Props) => {

    const service = new AdminService();
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(null);

    useEffect(() => {
        getLista();
    }, [])

   

    useEffect(() => {
        if(idSelector)
        if(idSelector)
            setID(idSelector);

    }, [idSelector])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(parseInt(e));
    }

    const getLista = () => {

        let cache = _single.getCacheItem("ProcessType");
        if(cache)
        {
            setLista(cache);
        }else{
            service.getProcessTypeConstants().subscribe((resp: any) => {           
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                    _single.setCacheItem("ProcessType",resp.DataBeanProperties.ObjectValue);
                }
            });
        }
    };

    return (
        <>
            <label >{label ?? 'Tipo de Aplicación'}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={0}>...</option>
                {lista &&
                    lista.map((item: any,index:number) => {
                        return (
                            <>
                                <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                            </>)
                    })
                }
            </select>
        </>
    )
}
